import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

let getDashboardsSourceToken;
export const getDashboards = ({
  token,
  limit,
  communityId,
  clientUEN = null,
  offset = 0,
  sourceToken = null
}) => {
  getDashboardsSourceToken = updateSourceToken(
    getDashboardsSourceToken,
    sourceToken
  );

  const requestUrl = `${TTP_API_URL}/data/financials`;
  //const requestUrl = `https://api.v2.tamtam.pro/data/financials`;

  let filter = [];

  if (clientUEN) {
    filter.push({
      property: "uen",
      value: clientUEN,
      operator: "eq"
    });
  }
  /*let filter = [
    {
      property: "id",
      value: communityId,
      operator: "eq"
    }
  ];*/

  const sort = [
    {
      property: "updatedAt",
      dir: "desc"
    }
  ];
  return axios
    .get(requestUrl, {
      cancelToken: getDashboardsSourceToken && getDashboardsSourceToken.token,
      params: {
        access_token: token,
        //access_token: "000076888ed482e12afe88a780a85b8a1685d20d",
        organization_id: communityId,
        sort: JSON.stringify(sort),
        //fields: fields.join(","),
        filter: JSON.stringify(filter),
        start: offset,
        limit
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/dashboard.js